import React, { useState, useEffect } from 'react'

import { Paper, List, ListItem, ListSubheader, TextField, makeStyles } from '@material-ui/core'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import DefaultItemList from './DefaultItemLIst/DefaultItemList'
import STT05ItemList from './STT05ItemList/STT05ItemList'

const ItemList = ({
  items,
  currentItems = [],
  selectedTags = [],
  tagSelected,
  itemClicked,
  structureCode,
  translate
}) => {
  const classes = useStyles()
  const [filterText, setFilterText] = useState('')
  const disableSearch = structureCode === 'STT05'

  useEffect(() => {
    if (structureCode === 'STT05') {
      setFilterText('')
    }
    return () => setFilterText('')
  }, [structureCode])

  let filteredItems = []
  if (structureCode !== 'STT05') {
    filteredItems = items.filter(
      item =>
        item.item_name?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.item_code?.toLowerCase().includes(filterText.toLowerCase())
    )
  }

  let display = (
    <DefaultItemList
      itemList={filteredItems}
      itemClicked={itemClicked}
      currentItems={currentItems}
    />
  )

  if (structureCode === 'STT05') {
    display = (
      <STT05ItemList
        itemList={items}
        selectedTags={selectedTags}
        tagSelected={tagSelected}
        translate={translate}
      />
    )
  }

  return (
    <Paper>
      <List dense className={classes.root}>
        <ListSubheader className={classes.listSection}>{translate('appraisalItem')}</ListSubheader>
        <ListItem>
          <TextField
            size={'small'}
            variant={'outlined'}
            fullWidth
            disabled={disableSearch}
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            label={translate('search')}
          />
        </ListItem>
        <ul className={classes.ul}>{display}</ul>
      </List>
    </Paper>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 400,
    paddingTop: 0
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  }
}))

export default withTranslate(ItemList)
